export const pageLimit = 50;

export const formatCurrency = (value, sign) => {
	if (!value) return '';
	if (sign) {
		return new Intl.NumberFormat('fr-FR', {
			style: 'currency',
			currency: 'XOF',
			maximumFractionDigits: 3,
		}).format(value);
	}
	return new Intl.NumberFormat('fr-FR').format(value).replace(' ', '.');
};

export const formatCurrencyCompress = (value) => {
	if (!value) return '';
	let formattedValue;
	if (value >= 1000000000) {
		// for milliard
		formattedValue = ((value / 1000000000).toFixed(1) + 'G')
	} else if (value >= 1000000) {
		// For millions
		formattedValue = (value / 1000000).toFixed(1) + 'M';
	} else if (value >= 1000) {
		// For thousands
		formattedValue = (value / 1000).toFixed(1) + 'K';
	} else {
		// For values less than 1000
		formattedValue = value.toFixed(1);
	}

	return formattedValue;
};

export const truncate = (str, n) => {
	if (!str) return '';
	return str?.length > n ? str.substr(0, n - 1) + '...' : str;
};

export const strClean = (str) => {
	if (!str) return '';
	return str
		.replace(/[^a-zA-Z0-9@._\-]/g, '') // Remove special characters
		.replace(/\s+/g, '') // Replace multiple spaces with a single space
		.trim(); // Trim leading and trailing spaces
};

export const formatDate = ($date, format = 'DD-MM-YYYY HH:mm') => {
	if (!$date) return '';
	const date = new Date($date);
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');

	return format
		.replace('YYYY', year)
		.replace('MM', month)
		.replace('DD', day)
		.replace('HH', hours)
		.replace('mm', minutes)
		.replace('ss', seconds);
};

export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

export const isEmptyArray = (arr) => arr?.length === 0;

export const sortArray = (arr, path = 'name') =>
	arr.sort((a, b) => a[path]?.localeCompare(b.name));

export const isGreaterThanZero = (value) => value > 0;

export const getMonthName = (monthIndex) => {
	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];
	return months[monthIndex];
};

export const getAuth = () => {
	const user = localStorage.getItem('user')
		? JSON.parse(localStorage.getItem('user'))
		: null;
	return user;
};

export const getDept = () => {
	const owner = localStorage.getItem('dept')
		? JSON.parse(localStorage.getItem('dept'))
		: null;
	return owner;
};

export const isAdmin = () => {
	const user = localStorage.getItem('user')
		? JSON.parse(localStorage.getItem('user'))
		: {};
	return user?.role === 'ADMIN';
};




export const getParams = (key, value, params) => {
	const newParams = { ...params, [key]: value };

	if (!['sortBy', 'limit', 'page'].includes(key)) {
		// Initialize filterKey and filterValue as arrays if they don't exist
		const filterKeys = params.filterKey ? params.filterKey.split(',') : [];
		const filterValues = params.filterValue
			? params.filterValue.split(',')
			: [];

		const keyIndex = filterKeys.indexOf(key);

		if (value) {
			if (keyIndex !== -1) {
				// Update existing value
				filterValues[keyIndex] = value;
			} else {
				// Add new key-value pair
				filterKeys.push(key);
				filterValues.push(value);
			}
		} else if (keyIndex !== -1) {
			// Remove key-value pair if value is empty
			filterKeys.splice(keyIndex, 1);
			filterValues.splice(keyIndex, 1);
		}

		newParams['filterKey'] = filterKeys.join(',');
		newParams['filterValue'] = filterValues.join(',');
	}

	return newParams;
};


